import framebottom1 from './frame1.png';
import framebottom2 from './frame2.png';
import framebottom3 from './frame3.png';
import framebottom4 from './frame4.png';
import framebottom5 from './frame5.png';
import framebottom6 from './frame6.png';
import framebottom7 from './frame7.png';
import framebottom8 from './frame8.png';
import framebottom9 from './frame9.png';
import framebottom10 from './frame10.png';
import framebottom11 from './frame11.png';
import framebottom12 from './frame12.png';
import framebottom13 from './frame13.png';
import framebottom14 from './frame14.png';
import framebottom15 from './frame15.png';
import framebottom16 from './frame16.png';
import framebottom17 from './frame17.png';

let framesBottom = [ framebottom1, framebottom2, framebottom3, framebottom4, framebottom5, framebottom6, framebottom7, framebottom8, framebottom9, framebottom10, framebottom11, framebottom12, framebottom13, framebottom14, framebottom15, framebottom16, framebottom17 ];
export default framesBottom;



// WEBPACK FOOTER //
// ./src/img/frame-bottom/FramesBottom.js